var path = '/static/assets/khapps/dss/dss_main/partials/includes/dssmain_container.html';
var html = "<kh-card layout=\"column\" card_details=\"{{ containerViewCard }}\"></kh-card>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;